import {Switch, Route, Redirect} from 'react-router-dom';
import ProtectedRoute from '../../common/ProtectedRoute';
import {
  LazyMessagingCenter,
  LazyPublicProfileRouter,
  LazyRequestForProposalsList,
  LazyHelpArticle,
  LazyArticlesList,
  LazyVerificationWizard,
  LazyAccountingAnalytics,
  LazyContractorSearchList,
  LazyResourcesListView,
  LazyEditProfile,
  LazyContractorDashboard,
  LazyFAQPage,
  LazyInvoicesTable,
  LazyOnboardingWizard,
  LazyContactsCRM,
} from '../../common/LazyLoader';
import ProjectCreationIndex from '../ProjectCreationWizard';
import PendingApplicationPopup from '../../common/dialogs/PendingApplicationPopup';

const MainContent = () => {
  return (
    <>
      <Switch>
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'render' is missing in type '{ path: stri... Remove this comment to see the full error message */}
        <ProtectedRoute path="/messages" component={LazyMessagingCenter} />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'render' is missing in type '{ exact: tru... Remove this comment to see the full error message */}
        <ProtectedRoute
          exact
          path="/my/profile/dashboard"
          component={LazyEditProfile}
        />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'render' is missing in type '{ exact: tru... Remove this comment to see the full error message */}
        <ProtectedRoute
          exact
          path="/home"
          component={LazyContractorDashboard}
        />
        <Route exact path="/create-project" component={ProjectCreationIndex} />
        {/* Todo - do we need these? */}
        <Route exact path="/profile/:id" component={LazyPublicProfileRouter} />
        <Route exact path="/profile" component={LazyPublicProfileRouter} />
        {/* END do we need these? */}
        <Route exact path="/user/:id" component={LazyPublicProfileRouter} />
        <Route exact path="/help-articles" component={LazyArticlesList} />
        <Route exact path="/help-articles/:id" component={LazyHelpArticle} />
        <Route path="/resources" component={LazyResourcesListView} />
        {/* <Route exact path="/resources/:id" component={ResourceDetails} /> */}
        <Route exact path="/FAQ" component={LazyFAQPage} />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'render' is missing in type '{ exact: tru... Remove this comment to see the full error message */}
        <ProtectedRoute
          exact
          path="/accounting/analytics"
          component={LazyAccountingAnalytics}
        />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'render' is missing in type '{ exact: tru... Remove this comment to see the full error message */}
        <ProtectedRoute
          exact
          path="/accounting/invoices"
          component={LazyInvoicesTable}
        />
        <Route
          exact
          path="/contractor-search"
          component={LazyContractorSearchList}
        />
        <Route
          exact
          path="/contractor-search/:province/:city"
          component={LazyContractorSearchList}
        />
        <Route
          exact
          path="/contractor-search/:province/:city/:category"
          component={LazyContractorSearchList}
        />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'render' is missing in type '{ exact: tru... Remove this comment to see the full error message */}
        <ProtectedRoute
          exact
          path="/verification"
          component={LazyVerificationWizard}
        />
        <Route path="/onboarding" component={LazyOnboardingWizard} />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'component' is missing in type '{ path: s... Remove this comment to see the full error message */}
        <ProtectedRoute
          path="/myAwardedRfps"
          render={(screenProps: $TSFixMe) => (
            <LazyRequestForProposalsList {...screenProps} type={'awarded'} />
          )}
        />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'component' is missing in type '{ path: s... Remove this comment to see the full error message */}
        <ProtectedRoute
          path="/myRfps"
          render={(screenProps: $TSFixMe) => (
            <LazyRequestForProposalsList {...screenProps} type={'my'} />
          )}
        />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'component' is missing in type '{ path: s... Remove this comment to see the full error message */}
        <ProtectedRoute
          path="/rfps"
          render={(screenProps: $TSFixMe) => (
            <LazyRequestForProposalsList {...screenProps} type={'contractor'} />
          )}
        />
        <Route
          path="/communityrfps"
          render={(screenProps) => (
            <LazyRequestForProposalsList {...screenProps} type={'community'} />
          )}
        />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'component' is missing in type '{ path: s... Remove this comment to see the full error message */}
        <ProtectedRoute
          path="/myproposals"
          render={(screenProps: $TSFixMe) => (
            <LazyRequestForProposalsList
              {...screenProps}
              type={'myproposals'}
            />
          )}
        />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'component' is missing in type '{ path: s... Remove this comment to see the full error message */}
        <ProtectedRoute
          path="/mysitevisits"
          render={(screenProps: $TSFixMe) => (
            <LazyRequestForProposalsList {...screenProps} type={'sitevisits'} />
          )}
        />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'render' is missing in type '{ exact: tru... Remove this comment to see the full error message */}
        <ProtectedRoute path="/mycontacts" component={LazyContactsCRM} />

        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'render' is missing in type '{ exact: tru... Remove this comment to see the full error message */}
        <ProtectedRoute
          path="/application/contractor/pending"
          component={PendingApplicationPopup}
        />
        {/* 404 Redirect To Homepage */}
        <Route render={() => <Redirect to={'/'} />} />
      </Switch>
    </>
  );
};

export default MainContent;
